import type { VolumePoint } from '../types/voip';

export const hourlyToday: VolumePoint[] = [
  { label: '8a', outbound: 6, inbound: 9, missed: 1 },
  { label: '9a', outbound: 14, inbound: 18, missed: 2 },
  { label: '10a', outbound: 21, inbound: 22, missed: 1 },
  { label: '11a', outbound: 19, inbound: 20, missed: 3 },
  { label: '12p', outbound: 9, inbound: 12, missed: 2 },
  { label: '1p', outbound: 12, inbound: 15, missed: 1 },
  { label: '2p', outbound: 18, inbound: 19, missed: 2 },
  { label: '3p', outbound: 16, inbound: 14, missed: 1 },
  { label: '4p', outbound: 11, inbound: 10, missed: 1 },
  { label: '5p', outbound: 5, inbound: 6, missed: 0 },
  { label: '6p', outbound: 2, inbound: 3, missed: 0 },
];

export const daily30: VolumePoint[] = [
  { label: 'Sep 6', outbound: 22, inbound: 31, missed: 2 },
  { label: 'Sep 7', outbound: 148, inbound: 151, missed: 12 },
  { label: 'Sep 8', outbound: 156, inbound: 160, missed: 11 },
  { label: 'Sep 9', outbound: 151, inbound: 149, missed: 14 },
  { label: 'Sep 10', outbound: 162, inbound: 158, missed: 10 },
  { label: 'Sep 11', outbound: 139, inbound: 147, missed: 13 },
  { label: 'Sep 12', outbound: 18, inbound: 29, missed: 3 },
  { label: 'Sep 13', outbound: 15, inbound: 24, missed: 2 },
  { label: 'Sep 14', outbound: 160, inbound: 166, missed: 15 },
  { label: 'Sep 15', outbound: 158, inbound: 155, missed: 12 },
  { label: 'Sep 16', outbound: 149, inbound: 161, missed: 11 },
  { label: 'Sep 17', outbound: 166, inbound: 170, missed: 13 },
  { label: 'Sep 18', outbound: 141, inbound: 150, missed: 10 },
  { label: 'Sep 19', outbound: 20, inbound: 33, missed: 2 },
  { label: 'Sep 20', outbound: 14, inbound: 26, missed: 1 },
  { label: 'Sep 21', outbound: 171, inbound: 168, missed: 14 },
  { label: 'Sep 22', outbound: 163, inbound: 172, missed: 16 },
  { label: 'Sep 23', outbound: 158, inbound: 164, missed: 12 },
  { label: 'Sep 24', outbound: 155, inbound: 159, missed: 11 },
  { label: 'Sep 25', outbound: 146, inbound: 153, missed: 13 },
  { label: 'Sep 26', outbound: 23, inbound: 35, missed: 3 },
  { label: 'Sep 27', outbound: 17, inbound: 27, missed: 2 },
  { label: 'Sep 28', outbound: 174, inbound: 177, missed: 15 },
  { label: 'Sep 29', outbound: 168, inbound: 171, missed: 14 },
  { label: 'Sep 30', outbound: 161, inbound: 166, missed: 12 },
  { label: 'Oct 1', outbound: 170, inbound: 162, missed: 13 },
  { label: 'Oct 2', outbound: 152, inbound: 158, missed: 11 },
  { label: 'Oct 3', outbound: 21, inbound: 30, missed: 2 },
  { label: 'Oct 4', outbound: 16, inbound: 25, missed: 1 },
  { label: 'Oct 5', outbound: 133, inbound: 148, missed: 14 },
];
